import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import SmoothScroll from "@/components/SmoothScroll";

import Home from "@/pages/Home";
import RealEstatePartner from "@/pages/RealEstatePartner";
import CommercialProjects from "@/pages/CommercialProjects";
import ResidentialRenovations from "@/pages/ResidentialRenovations";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ProjectChecklist from "@/pages/ProjectChecklist";
import Admin from "@/pages/Admin";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

const SITE = "Bevel Commercial Services";
const TITLES = {
    "/": `${SITE} — Tulsa Renovation Partner`,
    "/real-estate-partner": `Real Estate Partner | ${SITE}`,
    "/commercial-projects": `Commercial Projects | ${SITE}`,
    "/residential-renovations": `Residential Renovations | ${SITE}`,
    "/about": `About Us | ${SITE}`,
    "/contact": `Contact Us | ${SITE}`,
    "/project-checklist": `Project Checklist | ${SITE}`,
    "/privacy": `Privacy Policy | ${SITE}`,
    "/terms": `Terms of Use | ${SITE}`,
    "/admin": `Admin | ${SITE}`,
};

function Layout({ children }) {
    const location = useLocation();
    const isAdmin = location.pathname.startsWith("/admin");
    useEffect(() => {
        document.title = TITLES[location.pathname] || TITLES["/"];
    }, [location.pathname]);
    return (
        <>
            {!isAdmin && (
                <a
                    href="#main-content"
                    data-testid="skip-to-content-link"
                    className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[100] focus:px-5 focus:py-3 focus:bg-white focus:text-black focus:text-sm focus:font-semibold focus:rounded-full"
                >
                    Skip to main content
                </a>
            )}
            {!isAdmin && <Header />}
            <div id="main-content" tabIndex={-1} className="outline-none">
                {children}
            </div>
            {!isAdmin && <Footer />}
        </>
    );
}

export default function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <SmoothScroll />
                <ScrollToTop />
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route
                            path="/real-estate-partner"
                            element={<RealEstatePartner />}
                        />
                        <Route
                            path="/commercial-projects"
                            element={<CommercialProjects />}
                        />
                        <Route
                            path="/residential-renovations"
                            element={<ResidentialRenovations />}
                        />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route
                            path="/project-checklist"
                            element={<ProjectChecklist />}
                        />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </div>
    );
}
